import { render, staticRenderFns } from "./ComplianceSingleElementScoreDrillDown.vue?vue&type=template&id=3fb11dbc&"
import script from "./ComplianceSingleElementScoreDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceSingleElementScoreDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports